import store from '@store'
import { CITY } from "@src/config/location";
import { compareDesc } from 'date-fns';

/**
 * 品牌選項
 * @returns {(*&{text: *, value: *})[]}
 */
export function brandOptions(brand = []) {
  const storeBrands = brand || store.state.option.currentOption.brand || [];
  return [
    {
      text: '所有品牌',
      value: ''
    },
    ...storeBrands.map(item => {
      return {
        ...item,
        text: item.title,
        value: item.alias
      }
    })
  ]
}

/**
 * 聯絡我們品牌選項
 * @returns {(*&{text: *, value: *})[]}
 */
 export function contactBrandOptions() {
  const storeBrands = store.state.option.currentOption.brand || [];

  return [
    ...storeBrands.map(item => {
      return {
        ...item,
        text: item.title,
        value: item.alias
      }
    })
  ]
}

/**
 * 產業選項
 * @returns {(*&{text: *, value: *})[]}
 */
export function industryCategoryOptions(category = []) {
  const storeIndustryCategory = category || store.state.option.currentOption.industry_category || [];
  return [
    {
      text: '所有類別',
      value: ''
    },
    ...storeIndustryCategory.map(item => {
      return {
        ...item,
        text: item.title,
        value: item.alias
      }
    })
  ]
}

/**
 * 產品產業選項
 * @returns {(*&{text: *, value: *})[]}
 */
 export function productCategoryOptions() {
  const storeProductCategory = store.state.option.currentOption.product_parent_category || [];
  return [
    // {
    //   text: '所有類別',
    //   value: ''
    // },
    ...storeProductCategory.map(item => {
      return {
        ...item,
        text: item.title,
        value: item.alias
      }
    })
  ]
}

/**
 * 檔案類別選項
 * @returns {(*&{text: *, value: *})[]}
 */
export function downloadFileOptions() {
  const storeDownloadFileCategory = store.state.option.currentOption.download_file_category || [];
  return [
    {
      text: '所有類別',
      value: ''
    },
    ...storeDownloadFileCategory.map(item => {
      return {
        ...item,
        text: item.title,
        value: item.alias
      }
    })
  ]
}

/**
 * BOT檔案類別選項
 * @returns {(*&{text: *, value: *})[]}
 */
export function contractFileOptions() {
  const storeContractFileCategory = store.state.option.currentOption.contract_file_category || [];
  return [
    {
      text: '所有類別',
      value: ''
    },
    ...storeContractFileCategory.map(item => {
      return {
        ...item,
        text: item.title,
        value: item.alias
      }
    })
  ]
}

/**
 * 縣市選項
 * @returns {{text: *, value: *}[]}
 */
export function cityOptions(city=[]) {
  const configCity = city || CITY || [];

  return [
    {
      text: '所有縣市',
      value: ''
    },
    ...configCity.map(item => {
      return {
        text: item.name,
        value: item.name,
      }
    })
  ]
}

/**
 * 課程選項
 * @returns {{text: *, value: *}[]}
 */
export function eventOptions() {
  return [
    {
      text: '課程/活動',
      value: '',
    },
    {
      text: '課程',
      value: 'course',
    },
    {
      text: '活動',
      value: 'activity',
    }
  ]
}

/**
 * 課程類型選項
 * @returns {{text: *, value: *}[]}
 */
export function eventTypeOptions() {
  return [
    {
      text: '實體/線上',
      value: '',
    },
    {
      text: '實體',
      value: 'physical',
    },
    {
      text: '線上',
      value: 'online',
    }
  ]
}
/**
 * 性別類型選項
 * @returns {{text: *, value: *}[]}
 */
export function genderOptions() {
  return [
    {
      text: '先生',
      value: 'male',
    },
    {
      text: '小姐',
      value: 'female',
    },
  ]
}

/**
 * 搜尋類型選項
 * @returns {{text: *, value: *}[]}
 */
export function searchOptions() {
  return [
    {
      title: '產品品牌',
      alias: 'brand',
    },
    {
      title: '解決方案',
      alias: 'solution',
    },
    {
      title: '最新消息',
      alias: 'news',
    },
    {
      title: '課程活動',
      alias: 'course',
    },
    {
      title: '成功案例',
      alias: 'case',
    },
    {
      title: '檔案下載',
      alias: 'file',
    },
    
    {
      title: '產品影片',
      alias: 'video',
    },
  ]
}
/**
 * 資料顯示狀態類型選項
 * @returns {{text: *, value: *, query: {}}[]}
 */
 export function dataStatusOptions() {
  return [
    {
      text: 'A-Z排序',
      value: 'asc',
    },
    {
      text: 'Z-A排序',
      value: 'desc',
    },
    {
      text: '最新到最舊',
      value: 'newest',
    },
    {
      text: '最舊到最新',
      value: 'oldest',
    },
  ]
}

/**
 * 取得選項
 * @param options
 * @param value
 * @param type
 * @param key
 * @returns {string|*}
 */
export function getOption({ options, value, type = 'key', key }) {
  const optionItems = options
    .filter(item => {
      return item.value === value
    });

  const defaultValue = type === 'key'
    ? ''
    : {};

  const optionValue = () => {
    const keyValue = () => {
      const keyParts = key.split(".");

      return key.indexOf('.') !== -1
        ? optionItems[0]?.[keyParts[0]]?.[keyParts[1]] || ''
        : optionItems[0]?.[key] || ''
    };

    return type === 'key' && key
      ? keyValue()
      : optionItems[0] || {};
  };

  return !optionItems[0]
    ? defaultValue
    : optionValue()
}
